import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import { GroupTargetRole } from 'entities/Message';
import Message from 'entities/Message';

export type DraftAnnouncement = {
  __typename: 'DraftAnnouncement';
  body: string | null;
  attachmentId: string | null;
  targets: {
    __typename: 'DraftAnnouncementTarget';
    group_id: number;
    role: GroupTargetRole;
  }[];
};

type GetDraftAnnouncementQuery = {
  draftAnnouncement: DraftAnnouncement | null;
  showDraft: boolean | null;
};

// this query doesn't actually hit the server - it hits the
// client-side Apollo cache. we are essentially using the
// Apollo cache as a way to store local cross-component state
export const GET_DRAFT_ANNOUNCEMENT_QUERY = gql`
  {
    draftAnnouncement @client {
      body
      attachmentId
      targets {
        group_id
        role
      }
    }
    showDraft @client
  }
`;

export function saveDraftAnnouncement(draftAnnouncement: DraftAnnouncement | null) {
  const apolloClient = getApolloClientSingleton();
  // this simply writes data directly to the client-side Apollo cache
  apolloClient.writeData({
    data: {
      draftAnnouncement,
    },
  });
}

export function setShowDraftAnnouncement(showDraft: boolean) {
  const apolloClient = getApolloClientSingleton();
  // this simply writes data directly to the client-side Apollo cache
  apolloClient.writeData({
    data: {
      showDraft,
    },
  });
}

export function clearDraftAnnouncement() {
  saveDraftAnnouncement(null);
}

export const DraftAnnouncementContainer = ({
  children,
}: {
  children: (props: { draftAnnouncement: Message; showDraft: boolean | null }) => React.ReactNode;
}) => (
  <Query query={GET_DRAFT_ANNOUNCEMENT_QUERY}>
    {({ data }: { data: GetDraftAnnouncementQuery }) => {
      const { draftAnnouncement, showDraft } = data;

      // we need to convert the draftAnnouncement to a `Message` entity
      // because that's what all the rendering components expect
      const draftAnnouncementToMessage = new Message(draftAnnouncement);

      return children({ draftAnnouncement: draftAnnouncementToMessage, showDraft });
    }}
  </Query>
);
